module.exports = __webpack_public_path__ + "assets/3ce5e97714c8a172cb77f6c9590dd7ed.svg";